export default __webpack_public_path__ + "static/fontawesome-webfont-0317d582b93c20f68e059e389aecab33.woff2";